<template>
    <v-container fluid grid-list-sm>
      <v-layout class="d-flex justify-center">
        <v-flex md6>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">Solicitar documento oficial</h3>
              </div>
            </v-card-title>
            <v-card-text>
              <div style="height: 200px;" v-if="progress">
                <p>Generando el documento</p>
                <v-progress-linear
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
              <div v-else>
                <v-autocomplete
                  label="Documento"
                  :items="doctos"
                  item-value="id"
                  item-text="descripcion"
                  return-object
                  v-model="documento"
                ></v-autocomplete>
                <v-list two-line>
                  <v-subheader>Información:</v-subheader>
                  <v-list-tile v-if="documento">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ documento.clave }} - {{ documento.descripcion }}</v-list-tile-title>
                      <v-list-tile-sub-title class="text--primary">Costo: $ {{ documento.costo }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-btn color="primary" @click="generarReferencia">Generar referencia</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import fileSaver from 'file-saver'
  import { mapState } from 'vuex'

  export default {
    name: 'SolicitarPage',
    data: () => ({
      doctos: [],
      documento: null,
      progress: false
    }),
    mounted () {
      this.getDocumentos()
    },
    computed: {
      ...mapState({
        estudiante: state => state.user.profile
      })
    },
    methods: {
      getDocumentos () {
        axios.get('/doctos-oficiales')
          .then(result => {
            this.doctos = result.data.data
            console.log(this.doctos)
          })
      },
      generarReferencia () {
        const data = new FormData()
        data.append('noDeControl', this.estudiante.noDeControl)
        data.append('documento_id', this.documento.id)
        this.progress = true
        axios.post('/doctos-oficiales/solicitar', data, { responseType: 'arraybuffer' })
          .then(response => {
            this.progress = false
            this.documento = null
            const blob = new Blob([response.data], { type: response.headers['content-type'] })
            fileSaver.saveAs(blob, 'solicitud.pdf')
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/doctos-oficiales/SolicitarPage.vue